/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./chat.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./chat.component";
import * as i3 from "../../services/auth.service";
var styles_ChatComponent = [i0.styles];
var RenderType_ChatComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ChatComponent, data: {} });
export { RenderType_ChatComponent as RenderType_ChatComponent };
export function View_ChatComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["id", "trobbit-chatbot"]], null, null, null, null, null))], null, null); }
export function View_ChatComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-chat", [], null, null, null, View_ChatComponent_0, RenderType_ChatComponent)), i1.ɵdid(1, 638976, null, 0, i2.ChatComponent, [i3.AuthService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ChatComponentNgFactory = i1.ɵccf("app-chat", i2.ChatComponent, View_ChatComponent_Host_0, { enableBot: "enableBot" }, {}, []);
export { ChatComponentNgFactory as ChatComponentNgFactory };
